// tslint:disable
/**
 * Import-export manager api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CsvImport } from '../models';
import { Import } from '../models';
/**
 * ContractorApi - axios parameter creator
 * @export
 */
export const ContractorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Import contractor from csv.
         * @param {string} companyId 
         * @param {CsvImport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importContractorCsv(companyId: string, body: CsvImport, options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling importContractorCsv.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling importContractorCsv.');
            }
            const localVarPath = `/import/contractor/csv`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractorApi - functional programming interface
 * @export
 */
export const ContractorApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Import contractor from csv.
         * @param {string} companyId 
         * @param {CsvImport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importContractorCsv(companyId: string, body: CsvImport, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Import> {
            const localVarAxiosArgs = ContractorApiAxiosParamCreator(configuration).importContractorCsv(companyId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ContractorApi - factory interface
 * @export
 */
export const ContractorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Import contractor from csv.
         * @param {string} companyId 
         * @param {CsvImport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importContractorCsv(companyId: string, body: CsvImport, options?: any) {
            return ContractorApiFp(configuration).importContractorCsv(companyId, body, options)(axios, basePath);
        },
    };
};

/**
 * ContractorApi - object-oriented interface
 * @export
 * @class ContractorApi
 * @extends {BaseAPI}
 */
export class ContractorApi extends BaseAPI {
    /**
     * Import contractor from csv.
     * @param {string} companyId 
     * @param {CsvImport} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public importContractorCsv(companyId: string, body: CsvImport, options?: any) {
        return ContractorApiFp(this.configuration).importContractorCsv(companyId, body, options)(this.axios, this.basePath);
    }

}
